export default __webpack_public_path__ + "static/media/waterTapMobile.fddfcea5.jpg";